export const SET_EMAIL_NOTIFICATION = 'SET_EMAIL_NOTIFICATION'
export const SET_CANCEL = 'SET_CANCEL'
export const SET_GET_SETS = 'SET_GET_SETS'
export const SET_BKP = 'SET_BKP'
export const SET_SET_SETTINGS_SAVE = 'SET_SET_SETTINGS_SAVE'



// WEBPACK FOOTER //
// ./src/store/actions/settings.js